import { buildScopedI18n } from '../../utils/buildScopedI18n';
import triageEsCL from './locales/es-CL.json';
import triageEnUS from './locales/en-US.json';
import triagePtBR from './locales/pt-BR.json';

export const escriturasTriageI18n = buildScopedI18n({
  esCL: triageEsCL,
  enUS: triageEnUS,
  ptBR: triagePtBR,
});
